module.exports = __webpack_public_path__ + "img/c01_buildingtechashlarmasonry_Normal_ua.0c6af828.webp";